import { searchActivePatientPrivilege, searchAllPatientPrivilege, searchPatientPortalIntegratedPrivilege } from '../../constants/privilegeConstants';

export const searchPatientTabs = [
    {
        value: 'active',
        label: 'Active',
        key: 'patient-search-active',
        privilege: searchActivePatientPrivilege,
    },
    {
        value: 'all',
        label: 'All',
        key: 'patient-search-all',
        privilege: searchAllPatientPrivilege,
    },
    {
        value: 'patientPortalIntegrated',
        label: 'Patient Portal',
        key: 'patient-search-patient-portal-integrated',
        privilege: searchPatientPortalIntegratedPrivilege,
    },
];

export const a = 'b';
